import React, { useEffect, useState, useCallback } from "react";

import { Animated, Dimensions, Easing } from "react-native";
import { usePrevious } from "utils";
import { ANIMATION_DURATION } from "consts";

import { styles } from "screens/question/themeA/styles";

const slideIn = Easing.bezier(0.215, 0.61, 0.355, 1);
const slideOut = Easing.bezier(0.55, 0.055, 0.675, 0.19);

const createAnimation = (
  toValue,
  animation,
  duration = ANIMATION_DURATION / 2,
) => {
  return {
    toValue,
    duration,
    easing: animation,
    useNativeDriver: true,
  };
};

export const Slider = ({ sequence, children, RTL }) => {
  const [slider] = useState(new Animated.Value(1));

  const animateStart = useCallback(() => {
    Animated.timing(slider, createAnimation(0, slideIn)).start();
  }, [slider]);

  const animatePrev = useCallback(() => {
    Animated.sequence([
      Animated.timing(slider, createAnimation(1, slideOut)),
      Animated.timing(slider, createAnimation(-1, null, 0)),
      Animated.timing(slider, createAnimation(0, slideIn)),
    ]).start();
  }, [slider]);

  const animateNext = useCallback(() => {
    Animated.sequence([
      Animated.timing(slider, createAnimation(-1, slideOut)),
      Animated.timing(slider, createAnimation(1, null, 0)),
      Animated.timing(slider, createAnimation(0, slideIn)),
    ]).start();
  }, [slider]);

  const previousSequence = usePrevious(sequence);

  useEffect(() => {
    if (sequence > previousSequence) {
      animateNext();
    } else if (sequence < previousSequence) {
      animatePrev();
    }
  }, [animateNext, animatePrev, previousSequence, sequence]);

  useEffect(() => animateStart(), [animateStart]);

  const { width } = Dimensions.get("window");
  const outputRange = RTL ? [width, 0, -width] : [-width, 0, width];
  const rangeMap = { inputRange: [-1, 0, 1], outputRange };

  return (
    <Animated.View
      style={[
        styles.slider,
        { transform: [{ translateX: slider.interpolate(rangeMap) }] },
      ]}
    >
      {children}
    </Animated.View>
  );
};
